import React from 'react';
import moment from 'moment-timezone';
import styled from 'styled-components';
import { color, typeStyle, units } from '@m/alchemy-ui/esm';
import { Tooltip } from './Tooltip';

const RelativeTime = styled.time`
  font: ${typeStyle('captionM')};
  color: ${color('typeHeader')};
  padding-right: ${units(1)};
`;

export const RelativeDateWithTooltip = ({ time }: { time: string }) => {
  const tipDate = moment(time).format('h:mm A - D MMM YYYY');
  return (
    <Tooltip content={tipDate}>
      <RelativeTime>{moment(time).fromNow()}</RelativeTime>
    </Tooltip>
  );
};
